(() => {
  'use strict';

  async function addVariant(button) {
    const variantId = button.dataset.abVariantId;
    if (!variantId || button.disabled || button.classList.contains('is-loading')) return;

    const card = button.closest('.product-block');
    const status = card?.querySelector('.ab-card-sizes__status');
    const allButtons = card?.querySelectorAll('[data-ab-variant-id]') || [];
    allButtons.forEach((item) => item.disabled = true);
    button.classList.add('is-loading');
    if (status) { status.textContent = 'Adding…'; status.classList.remove('is-error'); }

    try {
      const sections = ['page-header', 'cart-drawer']
        .map((selector) => document.querySelector(selector))
        .filter(Boolean);
      const sectionIds = sections.map((el) => el.dataset.sectionId).filter(Boolean);
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      if (sectionIds.length) {
        body.append('sections', sectionIds.join(','));
        body.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this size.');

      if (data.sections) {
        sections.forEach((el) => {
          const html = data.sections[el.dataset.sectionId];
          if (html && typeof el.updateFromCartChange === 'function') el.updateFromCartChange(html);
        });
      }

      button.classList.remove('is-loading');
      button.classList.add('is-success');
      if (status) status.textContent = 'Added to bag';
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: Number(variantId) } }));

      if (window.theme?.settings?.afterAddToCart === 'drawer') {
        const drawer = document.querySelector('.js-cart-drawer, cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } else if (window.theme?.settings?.afterAddToCart === 'page') {
        window.location.href = window.theme?.routes?.cart || '/cart';
      }

      setTimeout(() => {
        button.classList.remove('is-success');
        if (status) status.textContent = '';
      }, 1800);
    } catch (error) {
      button.classList.remove('is-loading');
      if (status) {
        status.textContent = error.message || 'Could not add this size.';
        status.classList.add('is-error');
      }
    } finally {
      allButtons.forEach((item) => item.disabled = false);
    }
  }

  document.addEventListener('click', (event) => {
    const sizeButton = event.target.closest('[data-ab-variant-id]');
    if (sizeButton) {
      event.preventDefault();
      event.stopPropagation();
      addVariant(sizeButton);
    }
  });


  function sortCollectionByStock(root = document) {
    const grids = root.querySelectorAll
      ? root.querySelectorAll('.template-collection .product-grid[id^="product-grid-"]')
      : [];

    grids.forEach((grid) => {
      const cards = Array.from(grid.children).filter((item) => item.matches?.('.product-block'));
      if (cards.length < 2) return;

      cards.sort((a, b) => {
        const stockA = Number.parseInt(a.dataset.abTotalStock || '0', 10);
        const stockB = Number.parseInt(b.dataset.abTotalStock || '0', 10);
        if (stockB !== stockA) return stockB - stockA;
        return 0;
      });

      const fragment = document.createDocumentFragment();
      cards.forEach((card) => fragment.appendChild(card));
      grid.appendChild(fragment);
    });
  }

  function installStockSorting() {
    sortCollectionByStock(document);

    const observer = new MutationObserver((mutations) => {
      const collectionChanged = mutations.some((mutation) =>
        mutation.type === 'childList' &&
        mutation.target instanceof Element &&
        mutation.target.matches('.template-collection .product-grid[id^="product-grid-"]') &&
        mutation.addedNodes.length
      );
      if (collectionChanged) requestAnimationFrame(() => sortCollectionByStock(document));
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => sortCollectionByStock(document));
  }

  function installBackToTop() {
    if (document.getElementById('ab-back-to-top')) return;
    const button = document.createElement('button');
    button.id = 'ab-back-to-top';
    button.type = 'button';
    button.setAttribute('aria-label', 'Back to top');
    button.innerHTML = '↑';
    document.body.appendChild(button);
    const update = () => button.classList.toggle('is-visible', window.scrollY > 700);
    window.addEventListener('scroll', update, { passive: true });
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    update();
  }

  function initializeEnhancements() {
    installBackToTop();
    installStockSorting();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeEnhancements);
  else initializeEnhancements();
})();
